import { render, staticRenderFns } from "./Lase.vue?vue&type=template&id=27124008&scoped=true&"
import script from "./Lase.vue?vue&type=script&lang=js&"
export * from "./Lase.vue?vue&type=script&lang=js&"
import style0 from "./Lase.vue?vue&type=style&index=0&id=27124008&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27124008",
  null
  
)

export default component.exports